import React from 'react';
import PropTypes from 'prop-types';
import StepConnector from '@material-ui/core/StepConnector';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { isRedirectFromSummarySelector } from '../../../store/selectors/formConfigSelectors';

const useColorConnectorStyles = makeStyles((theme) => ({
  root: {
    padding: `0 ${theme.spacing(1)}px`,
  },
  active: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  completed: {
    '& $line': {
      borderColor: theme.palette.primary.main,
    },
  },
  line: {
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const CustomConnector = ({ active, completed }) => {
  const classes = useColorConnectorStyles();
  const isRedirectFromSummary = useSelector(isRedirectFromSummarySelector);

  const connectorClasses = () => {
    if (isRedirectFromSummary) {
      return cx(classes.root, classes.active);
    }
    return cx(classes.root, {
      [classes.active]: active,
      [classes.completed]: completed,
    });
  };

  return (
    <StepConnector
      classes={{
        line: classes.line,
        root: classes.root,
      }}
      className={connectorClasses()}
    />
  );
};

CustomConnector.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
};

CustomConnector.defaultProps = {
  active: false,
  completed: false,
};

export default CustomConnector;
